import { useMapEvents } from 'react-leaflet';

const MapClickHandler = ({ onMapClick, isActive }) => {
  useMapEvents({
    click(e) {
      if (isActive && onMapClick) {
        onMapClick(e.latlng.lat, e.latlng.lng);
      }
    }
  });
  
  return null;
};

export default MapClickHandler;

